import React, { useEffect, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormGroup } from "reactstrap";
import "./menu_detail/MenuDetailComponent.scss";
import { getActiveLanguage } from "../redux/home/actions";
import Loader from "./Loader/Loader";
import { useTranslation } from "react-i18next";
import _ from "lodash";
const LanguageMenuComponent = () => {
  let dispatch = useDispatch();
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const authBroker = useSelector((state) => state.auth.authBroker);
  
  const setLanguage = (type) => {
    setIsLoading(true);
    setShow(!show);
    i18n.changeLanguage(type == 1 ? "en" : "fr");
    dispatch(getActiveLanguage(type));
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    console.log("active-lang--", activeLanguage);
  }, [activeLanguage]);
  // useEffect(() => {
  //   if (!_.isEmpty(authBroker)) {
      
  //   }
  // }, []);

  return (
    <>
      <Loader start={isLoading} />
      <div className="language-selectpr" ref={ref}>
        <label id="exampleFile" for="exampleFile" className="">
          <button
            className="laguage-show d-flex align-items-center gap-2"
            onClick={(e) => handleClick(e)}
          >
            {activeLanguage == "1" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 60 60"
              >
                <rect width="60" height="60" fill="#00247D" />
                <path
                  d="M0 0 L60 60 M60 0 L0 60"
                  stroke="#FFFFFF"
                  stroke-width="8"
                />
                <path
                  d="M0 0 L60 60 M60 0 L0 60"
                  stroke="#CF142B"
                  stroke-width="5"
                />
                <path
                  d="M30 0 v60 M0 30 h60"
                  stroke="#FFFFFF"
                  stroke-width="15"
                />
                <path
                  d="M30 0 v60 M0 30 h60"
                  stroke="#CF142B"
                  stroke-width="10"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 60 60"
              >
                <rect width="20" height="60" x="0" fill="#0055A4" />
                <rect width="20" height="60" x="20" fill="#FFFFFF" />
                <rect width="20" height="60" x="40" fill="#EF4135" />
              </svg>
            )}
            {activeLanguage == "1" ? "EN" : "FR"}
          </button>
        </label>
        <Overlay
          show={show}
          target={target}
          placement="bottom"
          container={ref.current}
          containerPadding={20}
        >
          <Popover id="popover-contained">
            <Popover.Body>
              {/* <FormGroup>
                <input
                  type="file"
                  name="file"
                  accept="image/png,image/jpeg"
                  id="exampleFileCover"
                  style={{ display: "none" }}
                />
              </FormGroup> */}
              <ul className="d-flex gap-3 p-0 flex-column justify-content-between">
                <li
                  className="linkbtn d-flex align-items-center gap-2"
                  onClick={() => setLanguage(1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 60 60"
                  >
                    <rect width="60" height="60" fill="#00247D" />
                    <path
                      d="M0 0 L60 60 M60 0 L0 60"
                      stroke="#FFFFFF"
                      stroke-width="8"
                    />
                    <path
                      d="M0 0 L60 60 M60 0 L0 60"
                      stroke="#CF142B"
                      stroke-width="5"
                    />
                    <path
                      d="M30 0 v60 M0 30 h60"
                      stroke="#FFFFFF"
                      stroke-width="15"
                    />
                    <path
                      d="M30 0 v60 M0 30 h60"
                      stroke="#CF142B"
                      stroke-width="10"
                    />
                  </svg>
                  EN
                </li>
                <li
                  className="linkbtn d-flex align-items-center gap-2"
                  onClick={() => setLanguage(2)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 60 60"
                  >
                    <rect width="20" height="60" x="0" fill="#0055A4" />
                    <rect width="20" height="60" x="20" fill="#FFFFFF" />
                    <rect width="20" height="60" x="40" fill="#EF4135" />
                  </svg>
                  FR
                </li>
              </ul>
            </Popover.Body>
          </Popover>
        </Overlay>
      </div>
    </>
  );
};

export default LanguageMenuComponent;
